module.exports = __webpack_public_path__ + "static/img/w-check.fb96352.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/w-check.png
// module id = 3eXD
// module chunks = 1